import styled from "styled-components";

export const Root = styled.div`
  min-width: 0;
  width: 100%;
`;

export const DisplayButton = styled.button<{ $isActive?: boolean }>`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;
  display: block;
  min-width: 0;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  background: ${({ $isActive }) => ($isActive ? "#f2f4f7" : "transparent")};
  border-radius: 4px;

  &[aria-pressed="true"] {
    background: #f2f4f7;
  }
`;

export const EditorInput = styled.input<{ $hasError?: boolean }>`
  box-sizing: border-box;
  display: block;
  width: 100%;
  min-width: 0;
  font: inherit;
  color: inherit;
  background: #ffffff;
  border: 1px solid ${({ $hasError }) => ($hasError ? "#b42318" : "#6c6c6c")};
  border-radius: 4px;
  padding: 6px 8px;
  outline: none;

  &:focus {
    border-color: ${({ $hasError }) => ($hasError ? "#b42318" : "#222222")};
    box-shadow: 0 0 0 1px ${({ $hasError }) => ($hasError ? "#b42318" : "#222222")};
  }
`;

export const ErrorMessage = styled.span`
  display: block;
  margin-top: 4px;
  color: #b42318;
  font-size: 0.75rem;
`;
